import { render, staticRenderFns } from "./LeagueShare.vue?vue&type=template&id=8b20213c&scoped=true"
import script from "./LeagueShare.vue?vue&type=script&lang=js"
export * from "./LeagueShare.vue?vue&type=script&lang=js"
import style0 from "./LeagueShare.vue?vue&type=style&index=0&id=8b20213c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b20213c",
  null
  
)

export default component.exports